import { renderer } from '@thg-commerce/enterprise-core/src/Head'

import { Post } from '../../types'

interface ArticleHeadRendererProps {
  post: Post
  articleUrl: string
  defaultLocale: string
  i18nText: {
    defaultMetaDescription: string
  }
}

export const ArticleMetaRenderer = ({
  post,
  articleUrl,
  defaultLocale,
  i18nText,
}: ArticleHeadRendererProps) => {
  const metaNameTags = {
    'apple-itunes-app': `app-id=${post.seo?.appStoreId}, affiliate-data=${post.seo?.iTunesAffiliateCode}`,
    description: post.seo?.metaDesc || i18nText.defaultMetaDescription,
    robots: [post.seo?.metaRobotsNofollow, post.seo?.metaRobotsNoindex].join(
      ', ',
    ),
    googlebot:
      'index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1',
    bingbot:
      'index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1',
    'twitter:card': post.seo?.twitterExtraFields?.twitterCardType || '',
    'twitter:creator': post.seo?.twitterExtraFields?.twitterSite
      ? `@${post.seo?.twitterExtraFields?.twitterSite}`
      : '',
    'twitter:site': post.seo?.twitterExtraFields?.twitterSite
      ? `@${post.seo?.twitterExtraFields?.twitterSite}`
      : '',
  }

  const metaTags = {
    'og:locale': defaultLocale,
    'og:type': post.seo?.opengraphType || '',
    'og:title': post.seo?.opengraphTitle || '',
    'og:description': post.seo?.opengraphDescriptionDecoded || '',
    'og:url': articleUrl,
    'og:site_name': post.seo?.opengraphSiteName || '',
    'article:publisher': post.seo?.opengraphPublisher || '',
    'article:published_time': post.seo?.opengraphPublishedTime || '',
    'og:image': post.featuredImage?.mediaItemUrl || '',
    'og:image:width': post.featuredImage?.mediaDetails?.width?.toString() || '',
    'og:image:height':
      post.featuredImage?.mediaDetails?.height?.toString() || '',
  }

  const linkTags = {
    canonical: articleUrl,
  }

  return renderer([
    ...Object.entries(metaNameTags).map(([name, content]) => ({
      type: 'meta' as 'meta',
      props: {
        name,
        content,
      },
    })),
    ...Object.entries(metaTags).map(([property, content]) => ({
      type: 'meta' as 'meta',
      props: {
        property,
        content,
      },
    })),
    ...Object.entries(linkTags).map(([rel, href]) => ({
      type: 'link' as 'link',
      props: {
        rel,
        href,
      },
    })),
  ])
}
